export default __webpack_public_path__ + "static/media/Google_2015_logo.6c4dc3a1.svg";